<template>
  <section v-show="show">
    <div class="loader bottom"></div>
  </section>
</template>

<script>
export default {
  props: ['show']
}
</script>

<style lang="less" scoped>
@import "./../assets/style/config.less";
section{
  padding: 15px;
}
.loader {
    margin: .75rem auto;
    font-size: .75rem;
    position: relative;
    text-indent: -9999rem;
    border-top: .5rem solid rgba(255, 255, 255, 0.2);
    border-right: .5rem solid rgba(255, 255, 255, 0.2);
    border-bottom: .5rem solid rgba(255, 255, 255, 0.2);
    border-left: .5rem solid #ffffff;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
}
.loader,
.loader:after {
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.loading-wrap{ position:fixed; top:50%; left:50%; margin-top:-2.5rem; margin-left:-2.5rem; width:5rem; height:5rem; border-radius:1rem; background-color:rgba(0,0,0,.6); z-index:1000;}
.loading-mask{ position:fixed; top:0; bottom:0; width:100%; z-index:999; background-color:transparent;}
.loader.bottom{ border-top-color:@primary; border-right-color:@primary; border-left-color:@primary;}
.loader.bottom{ margin-bottom:2rem;}
.loader.bottom,.loader.bottom:after{ width:2rem; height:2rem;}
</style>